import { StLabel } from './Label.styled'

import type { LabelHTMLAttributes } from 'react'
import type { FontType } from '../../typography/types/FontType'

type LabelProps = Partial<LabelHTMLAttributes<HTMLLabelElement>> & {
  type?: FontType
}

const Label = (labelProps: LabelProps) => {
  return <StLabel {...labelProps} />
}

export { Label }
